var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.component,{tag:"div",on:{"forceUpdate":function($event){return _vm.getProfile()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }